export const GET_BOBIN_TYPES = 'GET_BOBIN_TYPES';
export const BOBIN_TYPE_REQUEST = 'BOBIN_TYPE_REQUEST';
export const CREATE_BOBIN_TYPE = 'CREATE_BOBIN_TYPE';
export const UPDATE_BOBIN_TYPE = 'UPDATE_BOBIN_TYPE';
export const DELETE_BOBIN_TYPE = 'DELETE_BOBIN_TYPE';
export const BOBIN_TYPE_REQUEST_FAILURE = 'BOBIN_TYPE_REQUEST_FAILURE';